
	
<div [formGroup]="form">
	<div *ngFor="let control of form.controls; let i = index;">
		<eze-input-container [label]="generateName(divisions[i])" *ngIf="!includes(exclusions, divisions[i].id)">
			<input ezeInput type="checkbox" [id]="control.value" [formControlName]="i">
		</eze-input-container>
	</div>
</div>

<!-- <pre>{{form.value | json}}</pre>
<br>
<pre>{{exclusions | json}}</pre>
<br>
<pre>{{selectedDivisions | json}}</pre>
<br>
<pre>{{selectedDivisionIds | json}}</pre> -->



